var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEyeVisible = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C12.1027 6 13 6.89725 13 8C13 9.10275 12.1027 10 11 10C9.89725 10 9 9.10275 9 8C9 6.89725 9.89725 6 11 6ZM11 4C8.791 4 7 5.791 7 8C7 10.2092 8.791 12 11 12C13.2092 12 15 10.2092 15 8C15 5.791 13.2092 4 11 4Z",
    fill: "#535961"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.77778C15.8469 1.77778 18.9067 6.22178 19.937 8C18.9049 9.78133 15.8457 14.2222 11 14.2222C6.15381 14.2222 3.09444 9.804 2.06319 8.03311C3.09375 6.24467 6.15381 1.77778 11 1.77778ZM11 0C3.66667 0 0 8.03689 0 8.03689C0 8.03689 3.66667 16 11 16C18.3333 16 22 8 22 8C22 8 18.3333 0 11 0Z",
    fill: "#535961"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEyeVisible, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/eye-visible.7ce214de.svg";
export { ForwardRef as ReactComponent };